'use strict';

module.exports = /*@ngInject*/
function(
    $rootScope,
    $timeout,
    AnthroConfig
) {
    var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd';

    return {
        templateUrl: AnthroConfig.location.root + '/partials/half-takeover.html',
        transclude: true,
        controller: function($scope, $element, $attrs) {
            var $html = angular.element('html');
            var $scoll = $element.find('[data-ht-scroll]');
            var $takeover = $element.find('[data-ht-panel]');

            // you can use this flag to reset the partial/parts of a partial
            // by setting an ng-if on your container based on this
            $scope.isHalfTakeoverOpen = false;

            $scope.openTakeover = function() {
                $takeover.off(transitionEnd);
                $scope.$broadcast('takeover:open');
                $scoll.scrollTop('0');
                $html.addClass('half-takeover-active');
                $scope.isHalfTakeoverOpen = true;

                // Timeout fixes animation issue in safari
                $timeout(function() {
                    $takeover.addClass('active');
                }, 0);

                return false;
            };

            $scope.closeTakeover = function() {
                $scope.$broadcast('takeover:close');
                $html.removeClass('half-takeover-active');

                // Timeout fixes animation issue in safari
                $timeout(function() {
                    $takeover.one(transitionEnd, function() {
                        $scope.$apply(function() {
                            $scope.$broadcast('takeover:closeComplete');
                            $scope.isHalfTakeoverOpen = false;
                        });

                    });
                    $takeover.removeClass('active');
                }, 0);

                return false;
            };
        },
        scope: true,
        link: function($scope, $elem, $attr, controller, transclude) {
            var $transclude = $elem.find('[data-ht-transclude]');

            function bindEvents() {
                $elem.on('click touchstart', '[data-ht-close]', $scope.closeTakeover);

                $elem.on('click touchstart', '[data-ht-scroll]', function(e) {
                    // prevent the event from bubbling up so that clicking on the scroll area won't close it
                    e.stopPropagation();
                });

                $rootScope.$on('open.halfTakeover', function(event, data) {
                    $scope.openTakeover();
                });
                $rootScope.$on('close.halfTakeover', function(event, data) {
                    $scope.closeTakeover();
                });
            }

            function initialize() {
                transclude($scope, function(clone, $scope) {
                    $transclude.append(clone);
                });

                bindEvents();
            }

            initialize();
        }
    };
};
